class SendAccessLinkPayloadMapper {
  toPersistence(domainData) {
    return {
      envio: domainData?.sendType,
    }
  }
}

export default new SendAccessLinkPayloadMapper()
